import { NOMAL_WIDTH, NOMAL_HEIGHT } from './config';

let deletedItemReg = [];


function genFileObjByUrl(pl) {
    const { picUrl, sequence } = pl;
    return {
        id: null,
        picUrl,
        pictureType: 1,
        width: NOMAL_WIDTH,
        height: NOMAL_HEIGHT,
        sequence,
    };
}

export function getPicList({
    newList, oldList, keyGen,
}) {
    // 加入deletedItemReg 是因为这个组件交换图片顺序是先删除后添加，所以得保留上一个删除的
    // 不然如果是交换，就找不到上一个图片带的信息了
    const oldListMap = [...deletedItemReg, ...oldList].reduce((prev, cur) => {
        let key = keyGen;
        if (keyGen instanceof Function) {
            key = keyGen(cur);
        }

        if (!prev[key]) {
            prev[key] = cur;
        }
        return prev;
    }, {});
    const newObjectList = newList.map((i, idx) => {
        const target = oldListMap[i];
        if (target) {
            return target;
        }
        return genFileObjByUrl({ picUrl: i, sequence: idx });
    });
    return newObjectList;
}

export function skuPictureListInput(urlList) {
    const curList = this.form.skuPictureList.map((i) => i.picUrl);
    if (urlList.join() === curList.join()) {
        // 完全一样，不需要任何操作
        return;
    }
    if (urlList.length > curList.length) {
        // 用户新增
        const newList = getPicList({ newList: urlList, oldList: curList, keyGen: (obj) => `${obj.id}-${obj.picUrl}` });
        this.updateField('skuPictureList', newList);
    }
    if (urlList.length < curList.length) {
        // 用户删除
        for (let i = 0; i < curList.length; i++) {
            if (urlList[i] !== curList[i]) {
                const newList = [...this.form.skuPictureList];
                deletedItemReg = newList.splice(i, 1);
                this.updateField('skuPictureList', newList);
                this.updateField('yyPicture', this.form.yyPicture);
                break;
            }
        }
    }
    if (urlList.length === curList.length) {
        // 用户替换图片url
        const newList = [...this.form.skuPictureList];
        let idx = -1;
        let target = newList.find((i, index) => {
            if (i.picUrl !== urlList[index]) {
                idx = index;
                return true;
            }
            return false;
        });
        if (target) {
            target = { ...target };
            target.picUrl = urlList[idx];
            newList.splice(idx, 1, target);
            this.updateField('skuPictureList', newList);
            this.updateField('yyPicture', this.form.yyPicture);
        }
    }
}


export function imgUrlTransformObject({
    picUrl, type, width = NOMAL_WIDTH, height = NOMAL_HEIGHT, sequence = 0, originalPicUrl, pictureContentType = -1, id,
}) {
    return {
        id: id || null,
        pictureType: type,
        picUrl,
        originalPicUrl: originalPicUrl || '',
        sequence,
        width,
        pictureContentType, // 区分是否是配料图,配料图是1,其他都是-1
        height,
    };
}

export function imgIsGif(url) {
    if (!url) {
        return false;
    }
    const strArr = url.split('.');
    return /gif/.test(strArr[strArr.length - 1]);
}

// 基础库spu需要审核的属性字典，用于提交时的提示文案拼接
export const spuInfoAttrsDic = {
    brandId: '品牌',
    name: '商品名称(SPU)',
    categoryId: '商品分类',
    specActual: '规格',
    // spec: '关联规格',
    skuName: '商品名称(SKU)',
    taste: '口味',
    importFlag: '是否进口',
    code: '主条形码',
    produceAreaName: '产地',
    subTitle: '副标题',
    // questions: '常见问答',
    lbPicture: '商品列表图',
    // dlbPicture: '动态列表图',
    // wmPictureList: '外卖侧用图',
    video: '商品短视频',
    skuPictureList: '商品主图',
    description: '商品详情',
};
// 运营信息修改属性类型为 Array Object 列表
const contentAttrsIsObjList = [
    // 'questions',
    'lbPicture',
    // 'dlbPicture',
    // 'wmPictureList',
    'video',
    'skuPictureList',
];
// 判断spu对象需要审核的属性是否被修改，同时返回审核字段中文名称
export function jageReviewAttrs(oldObj, newObj) {
    const sourceList = [];
    function recurse(oldItem, newItem) {
        const toString = Object.prototype.toString;
        Object.keys(oldItem).forEach((key) => {
            if ((toString.call(oldItem[key]) === '[object String]' || toString.call(oldItem[key]) === '[object Number]') && oldItem[key] !== newItem[key] && Object.prototype.hasOwnProperty.call(spuInfoAttrsDic, key)) {
                sourceList.push(spuInfoAttrsDic[key]);
            }
            // 修改销售规格会影响到外卖图列表的数据变动，在这里做个详细判断去掉影响
            // if (contentAttrsIsObjList.includes(key) && key === 'wmPictureList' && Object.prototype.hasOwnProperty.call(spuInfoAttrsDic, key)) {
            //     const oldWmpicList = [];
            //     const newWmpicList = [];
            //     oldItem[key].forEach((val) => {
            //         oldWmpicList.push({
            //             height: `${val.height}`,
            //             picUrl: `${val.picUrl}`,
            //             pictureType: `${val.pictureType}`,
            //             sequence: `${val.sequence}`,
            //             width: `${val.width}`,
            //         });
            //     });
            //     newItem[key].forEach((val) => {
            //         newWmpicList.push({
            //             height: `${val.height}`,
            //             picUrl: `${val.picUrl}`,
            //             pictureType: `${val.pictureType}`,
            //             sequence: `${val.sequence}`,
            //             width: `${val.width}`,
            //         });
            //     });
            //     if (JSON.stringify(oldWmpicList) !== JSON.stringify(newWmpicList)) {
            //         sourceList.push(spuInfoAttrsDic[key]);
            //     }
            // }
            if (key !== 'wmPictureList' && contentAttrsIsObjList.includes(key) && JSON.stringify(oldItem[key]) !== JSON.stringify(newItem[key]) && Object.prototype.hasOwnProperty.call(spuInfoAttrsDic, key)) {
                if (oldItem[key] !== null || newItem[key] !== undefined) {
                    sourceList.push(spuInfoAttrsDic[key]);
                }
            }
            // 判断遍历值是sku信息，条形码信息，然后再进行深层遍历
            if (toString.call(oldItem[key]) === '[object Array]' && (key === 'skuBaseList' || key === 'skuCodeList')) {
                if ((oldItem[key].length !== newItem[key].length) && key === 'skuBaseList') {
                    // 删除销售规格，关联规格、规格、口味进审核
                    sourceList.push(spuInfoAttrsDic.specActual);
                    sourceList.push(spuInfoAttrsDic.spec);
                    sourceList.push(spuInfoAttrsDic.taste);
                } else {
                    oldItem[key].forEach((arr, index) => {
                        if (arr && newItem[key][index]) {
                            recurse(arr, newItem[key][index]);
                        }
                    });
                }
            }
        });
    }
    recurse(oldObj, newObj);
    return [...new Set(sourceList)];
}
